import moment from 'moment'

export const isViewedToday = (lastViewedAt: Date | null | undefined): boolean =>
  lastViewedAt != null && moment(lastViewedAt).isSame(moment(), 'day')

/**
 * Viewing marks the participant as checked for the day, but unread messages or a draft mean there is
 * something left to do, so the bar stays hidden until both are cleared.
 */
export const shouldShowViewedTodayIndicator = (
  lastViewedAt: Date | null | undefined,
  newMessagesCount: number | undefined,
  hasDraftMessage: boolean
): boolean => isViewedToday(lastViewedAt) && (newMessagesCount ?? 0) === 0 && !hasDraftMessage
